'use strict';

const jQuery = require('jquery');

const RequestHandler = require('./../../../core/requestHandler');

module.exports.post = (data) => {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let dfd = jQuery.Deferred();

    RequestHandler.setBaseUrl('/api');
    RequestHandler.create('media-center/medias', data).done(function(object, response) {
        dfd.resolve(object);
    }).fail(function() {
        dfd.reject();
    });
    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd.promise();
};

module.exports.edit = (data, uid) => {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let dfd = jQuery.Deferred();

    RequestHandler.setBaseUrl('/api');
    RequestHandler.update('media-center/medias/' + uid, data).done(function(object, response) {
        dfd.resolve(object);
    }).fail(function() {
        dfd.reject();
    });
    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd.promise();
};

module.exports.findBy = function(data = {}) {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let dfd;

    RequestHandler.setBaseUrl('/api');
    dfd = RequestHandler.read('media-center/medias', data);
    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};

module.exports.delete = function(uid) {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let dfd;

    RequestHandler.setBaseUrl('/api');
    dfd = RequestHandler.del('media-center/medias', {uid});
    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};
